// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3e1dg","location":"Header_location__1vdV5"};